import React from "react";

// Serializa los parámetros como x-www-form-urlencoded
const serializeParams = (params) =>
  Object.entries(params)
    .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
    .join("&");

const modalStyle = {
  position: "fixed",
  top: "0",
  left: "0",
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const contentStyle = {
  position: "relative",
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  width: "90%",
  maxWidth: "360px",
  textAlign: "center",
  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
};

class EncuestaModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paso: 1,
      rating: null,
      comentario: "",
      enviado: false,
    };
  }

  handleRatingClick = (value) => {
    this.setState({ rating: value, paso: 2 });
  };

  handleComentarioChange = (event) => {
    this.setState({ comentario: event.target.value });
  };

  enviarEncuesta = () => {
    const { rating, comentario } = this.state;

    let userId = localStorage.getItem("chatUserId");
    if (!userId) {
      userId = crypto.randomUUID();
      localStorage.setItem("chatUserId", userId);
    }

    const params = {
      userId: userId,
      respuestaIA: rating,
      comentario: comentario,
    };

    const serializedParams = serializeParams(params);

    fetch("https://laravel-helpdesk.uaem.mx/api/store-satisfaccion", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: serializedParams,
    })
      .then(() => {
        this.setState({ enviado: true });
        setTimeout(this.props.onClose, 2000);
      })
      .catch((error) => {
        console.error("Error al enviar la encuesta:", error);
      });
  };

  render() {
    const { onClose } = this.props;
    const { paso, comentario, enviado } = this.state;

    return (
      <div style={modalStyle}>
        <div style={contentStyle}>
          {/* Botón de cerrar (❌) */}
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "transparent",
              border: "none",
              fontSize: "18px",
              cursor: "pointer",
            }}
            aria-label="Cerrar"
          >
            ❌
          </button>

          {enviado ? (
            <p>¡Gracias por tu opinión!</p>
          ) : (
            <>
              {paso === 1 && (
                <>
                  <p style={{ fontSize: '24px', fontWeight: 'bold' }}>Califica tu experiencia usando el asistente</p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "10px 0" }}>
                    <span style={{ fontSize: "12px" }}>Pobre</span>
                    <div style={{ display: "flex", gap: "8px" }}>
                      {[1, 2, 3, 4, 5].map((num) => (
                        <button
                          key={num}
                          onClick={() => this.handleRatingClick(num)}
                          style={{
                            padding: "10px 15px",
                            fontSize: "16px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                            backgroundColor: "#f7f7f7",
                            cursor: "pointer",
                          }}
                        >
                          {num}
                        </button>
                      ))}
                    </div>
                    <span style={{ fontSize: "12px" }}>Excelente</span>
                  </div>
                </>
              )}

              {paso === 2 && (
                <>
                  <p style={{ fontSize: '24px', fontWeight: 'bold' }}>¿Cómo podríamos mejorar tu experiencia?</p>
                  <textarea
                    placeholder="Escribe tu sugerencia aquí..."
                    value={comentario}
                    onChange={this.handleComentarioChange}
                    rows={4}
                    maxLength={150}
                    style={{
                      width: "90%",
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      resize: "none",
                    }}
                  />
                  <p style={{ fontSize: "12px", color: "#666", textAlign: "right" }}>
                    {comentario.length}/150 caracteres
                  </p>

                  <button
                    onClick={this.enviarEncuesta}
                    style={{
                      marginTop: "15px",
                      backgroundColor: "#3386d8",
                      color: "#fff",
                      border: "none",
                      padding: "8px 15px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Enviar
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default EncuestaModal;
